<script setup>
import { computed } from 'vue';
import TabButton from './TabButton.vue';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: null,
  },
  initialActiveTab: {
    type: Number,
    default: 0,
  },
  tabs: {
    type: Array,
    required: true,
    validator: value => {
      return value.every(
        tab =>
          typeof tab.label === 'string' &&
          (tab.count ? typeof tab.count === 'number' : true)
      );
    },
  },
});

const emit = defineEmits(['update:modelValue', 'tabChanged']);

const activeTabIndex = computed(() => {
  if (props.modelValue === null) return props.initialActiveTab;

  const index = props.tabs.findIndex(
    (tab, tabIndex) => (tab.value ?? tabIndex) === props.modelValue
  );
  return index < 0 ? props.initialActiveTab : index;
});

const selectTab = index => {
  if (props.tabs[index].disabled) return;
  emit('update:modelValue', props.tabs[index].value ?? index);
  emit('tabChanged', props.tabs[index]);
};
</script>

<template>
  <div
    class="flex w-full min-w-0 flex-wrap items-end gap-x-0 gap-y-1"
    role="tablist"
  >
    <TabButton
      v-for="(tab, index) in tabs"
      :key="tab.value ?? index"
      :label="tab.label"
      :count="tab.count"
      :active="activeTabIndex === index"
      :disabled="tab.disabled"
      @select="selectTab(index)"
    />
  </div>
</template>
